module.exports = __webpack_public_path__ + "static/media/layers_icon.cf80f602.svg";